import {
  TREQUEST_GetMaterialRequestDetails,
  TREQUEST_GetMaterialRequestsListing,
  TRESPONSE_GetMaterialRequestsListing,
  TMaterialRequestListingItemDTO,
  TFabricItemDTO,
  TTrimItemDTO,
  TDetailedInfoForMaterialRequestOrderDTO,
  TREQUEST_MaterialRequestCounts,
  TRESPONSE_MaterialRequestCounts,
  TMaterialRequestType,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum MaterialRequestsActions {
  ClearAndFetchMaterialRequestCounts = 'ClearAndFetchMaterialRequestCounts',
  ClearAndFetchMaterialRequestCountsSuccess = 'ClearAndFetchMaterialRequestCountsSuccess',

  ClearAndFetchWarehouseMaterialRequests = 'ClearAndFetchWarehouseMaterialRequests',
  ClearAndFetchWarehouseMaterialRequestsSuccess = 'ClearAndFetchWarehouseMaterialRequestsSuccess',
  ClearAndFetchMaterialRequestDetails = 'ClearAndFetchMaterialRequestDetails',
  ClearAndFetchMaterialRequestDetailsSuccess = 'ClearAndFetchMaterialRequestDetailsSuccess',

  UpdateSelectedMaterialRequestOrder = 'UpdateSelectedMaterialRequestOrder',
  ClearSelectedMaterialRequestOrderAndMaterialDetails = 'ClearSelectedMaterialRequestOrderAndMaterialDetails',
  AddItemsToTheSelectedMaterialRequestOrder = 'AddItemsToTheSelectedMaterialRequestOrder',
  ClearAllAddedItemsInSelectedMaterialRequestOrder = 'ClearAllAddedItemsInSelectedMaterialRequestOrder',

  MaterialRequestsNoAction = 'MaterialRequestsNoAction',
}

export class ClearAndFetchMaterialRequestCounts implements Action {
  readonly type = MaterialRequestsActions.ClearAndFetchMaterialRequestCounts;
  constructor(public payload: TREQUEST_MaterialRequestCounts) {}
}

export class ClearAndFetchMaterialRequestCountsSuccess implements Action {
  readonly type = MaterialRequestsActions.ClearAndFetchMaterialRequestCountsSuccess;
  constructor(public res: TRESPONSE_MaterialRequestCounts) {}
}

export class ClearAndFetchWarehouseMaterialRequests implements Action {
  readonly type = MaterialRequestsActions.ClearAndFetchWarehouseMaterialRequests;
  constructor(public payload: TREQUEST_GetMaterialRequestsListing) {}
}

export class ClearAndFetchWarehouseMaterialRequestsSuccess implements Action {
  readonly type = MaterialRequestsActions.ClearAndFetchWarehouseMaterialRequestsSuccess;
  constructor(public res: TRESPONSE_GetMaterialRequestsListing) {}
}

export class ClearAndFetchMaterialRequestDetails implements Action {
  readonly type = MaterialRequestsActions.ClearAndFetchMaterialRequestDetails;
  constructor(public payload: TREQUEST_GetMaterialRequestDetails, public requestStatus: TMaterialRequestType) {}
}

export class ClearAndFetchMaterialRequestDetailsSuccess implements Action {
  readonly type = MaterialRequestsActions.ClearAndFetchMaterialRequestDetailsSuccess;
  constructor(
    public FABRIC: TDetailedInfoForMaterialRequestOrderDTO[],
    public TRIM: TDetailedInfoForMaterialRequestOrderDTO[],
    public receiverLocationId: string,
  ) {}
}

export class UpdateSelectedMaterialRequestOrder implements Action {
  readonly type = MaterialRequestsActions.UpdateSelectedMaterialRequestOrder;
  constructor(public requestItem: TMaterialRequestListingItemDTO) {}
}

export class ClearSelectedMaterialRequestOrderAndMaterialDetails implements Action {
  readonly type = MaterialRequestsActions.ClearSelectedMaterialRequestOrderAndMaterialDetails;
  constructor() {}
}

export class AddItemsToTheSelectedMaterialRequestOrder implements Action {
  readonly type = MaterialRequestsActions.AddItemsToTheSelectedMaterialRequestOrder;
  constructor(
    public itemType: 'FABRIC' | 'TRIMS',
    public itemUniqueKey: string,
    public items: TFabricItemDTO[] | TTrimItemDTO[],
  ) {}
}

export class ClearAllAddedItemsInSelectedMaterialRequestOrder implements Action {
  readonly type = MaterialRequestsActions.ClearAllAddedItemsInSelectedMaterialRequestOrder;
  constructor() {}
}

export class MaterialRequestsNoAction implements Action {
  readonly type = MaterialRequestsActions.MaterialRequestsNoAction;
  constructor() {}
}

export type TRequestActionTypes =
  | ClearAndFetchMaterialRequestCounts
  | ClearAndFetchMaterialRequestCountsSuccess
  | ClearAndFetchWarehouseMaterialRequests
  | ClearAndFetchWarehouseMaterialRequestsSuccess
  | ClearAndFetchMaterialRequestDetails
  | ClearAndFetchMaterialRequestDetailsSuccess
  | UpdateSelectedMaterialRequestOrder
  | ClearSelectedMaterialRequestOrderAndMaterialDetails
  | AddItemsToTheSelectedMaterialRequestOrder
  | ClearAllAddedItemsInSelectedMaterialRequestOrder
  | MaterialRequestsNoAction;
